// removed by extract-text-webpack-plugin
module.exports = {"root":"address-grid-form--root--2qU1L6QZ","add-address":"address-grid-form--add-address--1g561fQ2","addAddress":"address-grid-form--add-address--1g561fQ2","button-text":"address-grid-form--button-text--2qxz4XRS","buttonText":"address-grid-form--button-text--2qxz4XRS","button-container":"address-grid-form--button-container--ojT7Jgt9","buttonContainer":"address-grid-form--button-container--ojT7Jgt9"};


//////////////////
// WEBPACK FOOTER
// ./views/addresses/address-grid-form/styles.css
// module id = ./views/addresses/address-grid-form/styles.css
// module chunks = 0